import React, { useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Función auxiliar para convertir fecha ISO a YYYY-MM-DD
const formatDateForInput = (dateString) => {
	if (!dateString) return '';
	try {
		const date = new Date(dateString);
		if (isNaN(date.getTime())) return '';
		return date.toISOString().split('T')[0];
	} catch {
		return '';
	}
};

export function Projects({ projects = [], onUpdate }) {
	const [modalOpen, setModalOpen] = useState(false);
	const [editingIndex, setEditingIndex] = useState(null);
	const [formData, setFormData] = useState({
		nombreProyecto: '',
		cliente: '',
		estatus: '',
		fechaInicio: '',
		fechaFin: '',
		detallesProyecto: ''
	});

	const handleOpenModal = (index = null) => {
		if (index !== null) {
			// Editar proyecto existente
			const proj = projects[index];
			setFormData({
				nombreProyecto: proj.nombreProyecto || '',
				cliente: proj.cliente || '',
				estatus: proj.estatus || '',
				fechaInicio: formatDateForInput(proj.fechaInicio),
				fechaFin: formatDateForInput(proj.fechaFin),
				detallesProyecto: proj.detallesProyecto || ''
			});
			setEditingIndex(index);
		} else {
			// Nuevo proyecto
			setFormData({
				nombreProyecto: '',
				cliente: '',
				estatus: '',
				fechaInicio: '',
				fechaFin: '',
				detallesProyecto: ''
			});
			setEditingIndex(null);
		}
		setModalOpen(true);
	};

	const handleCloseModal = () => {
		setModalOpen(false);
		setEditingIndex(null);
		setFormData({
			nombreProyecto: '',
			cliente: '',
			estatus: '',
			fechaInicio: '',
			fechaFin: '',
			detallesProyecto: ''
		});
	};

	const handleSave = () => {
		if (!formData.nombreProyecto || !formData.estatus || !formData.fechaInicio) {
			alert('Por favor completa los campos requeridos: Nombre del Proyecto, Estatus y Fecha de Inicio');
			return;
		}

		const newProject = {
			nombreProyecto: formData.nombreProyecto,
			cliente: formData.cliente || null,
			estatus: formData.estatus,
			fechaInicio: formData.fechaInicio,
			fechaFin: formData.fechaFin || null,
			detallesProyecto: formData.detallesProyecto || null
		};

		let updatedProjects;
		if (editingIndex !== null) {
			// Actualizar proyecto existente
			const existingProj = projects[editingIndex];
			updatedProjects = [...projects];
			updatedProjects[editingIndex] = {
				...existingProj,
				...newProject
			};
		} else {
			// Agregar nuevo proyecto
			updatedProjects = [...projects, newProject];
		}

		if (onUpdate) {
			onUpdate(updatedProjects);
		}
		handleCloseModal();
	};

	const handleDelete = (index) => {
		if (window.confirm('¿Estás seguro de que deseas eliminar este proyecto?')) {
			const updatedProjects = projects.filter((_, i) => i !== index);
			if (onUpdate) {
				onUpdate(updatedProjects);
			}
		}
	};

	const formatDateRange = (fechaInicio, fechaFin) => {
		if (!fechaInicio) return '';
		const startDate = new Date(fechaInicio);
		const startStr = startDate.toLocaleDateString('es-ES', { month: 'short', year: 'numeric' });
		
		if (fechaFin) {
			const endDate = new Date(fechaFin);
			const endStr = endDate.toLocaleDateString('es-ES', { month: 'short', year: 'numeric' });
			return `${startStr} - ${endStr}`;
		}
		return startStr;
	};

	return <div id="projects_bx" className="job-bx bg-white m-b30">
		<div className="d-flex">
			<h5 className="m-b15">Proyectos</h5>
			<Link to={"#"} onClick={() => handleOpenModal(null)} className="site-button add-btn button-sm"><i className="bi bi-plus"></i> Nuevo</Link>
		</div>
		{projects.length > 0 ? (
			<div className='list-row'>
				{projects.map((proj, index) => (
					<div key={proj.id || index} className='list-line'>
						<div className='d-flex justify-content-between'>
							<h6 className="font-14 m-b0">{proj.nombreProyecto || 'Sin nombre especificado'}</h6>
							<div>
								<span onClick={() => handleOpenModal(index)} className="site-button add-btn button-sm mr-2"><i className="fa fa-pencil m-r5"></i> Editar</span>
								<span onClick={() => handleDelete(index)} className="site-button add-btn button-sm" style={{ backgroundColor: '#dc3545', borderColor: '#dc3545' }}><i className="fa fa-trash m-r5"></i> Eliminar</span>
							</div>
						</div>
						{proj.cliente && (
							<p className="m-b0">Cliente: {proj.cliente}</p>
						)}
						<p className="m-b0">Estatus: {proj.estatus || 'Sin estatus especificado'}</p>
						<p className="m-b0">{formatDateRange(proj.fechaInicio, proj.fechaFin)}</p>
						{proj.detallesProyecto && (
							<p className="m-b0">{proj.detallesProyecto}</p>
						)}
					</div>
				))}
			</div>
		) : (
			<p className="m-b0">No has agregado proyectos aún. Haz clic en "Nuevo" para agregar uno.</p>
		)}

		<Modal className="modal fade modal-bx-info editor" show={modalOpen} onHide={handleCloseModal}>
			<div className="modal-dialog my-0" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title" id="ProjectsModalLongTitle">
							{editingIndex !== null ? 'Editar Proyecto' : 'Agregar Proyecto'}
						</h5>
						<button type="button" className="close" onClick={handleCloseModal}>
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div className="modal-body">
						<form>
							<div className="row">
								<div className="col-lg-12 col-md-12">
									<div className="form-group">
										<label>Nombre del Proyecto *</label>
										<input 
											type="text" 
											className="form-control" 
											placeholder="Introduce el nombre del proyecto" 
											value={formData.nombreProyecto}
											onChange={(e) => setFormData({ ...formData, nombreProyecto: e.target.value })}
										/>
									</div>
								</div>
								<div className="col-lg-12 col-md-12">
									<div className="form-group">
										<label>Cliente</label>
										<input 
											type="text" 
											className="form-control" 
											placeholder="Introduce el nombre del cliente" 
											value={formData.cliente}
											onChange={(e) => setFormData({ ...formData, cliente: e.target.value })}
										/>
									</div>
								</div>
								<div className="col-lg-12 col-md-12">
									<div className="form-group">
										<label>Estatus del Proyecto *</label>
										<div className="row">
											<div className="col-lg-6 col-md-6 col-sm-6 col-6">
												<div className="custom-control custom-radio">
													<input 
														type="radio" 
														className="custom-control-input" 
														id="inprogress" 
														name="estatus" 
														value="En Proceso"
														checked={formData.estatus === 'En Proceso'}
														onChange={(e) => setFormData({ ...formData, estatus: e.target.value })}
													/>
													<label className="custom-control-label" htmlFor="inprogress">En Proceso</label>
												</div>
											</div>
											<div className="col-lg-6 col-md-6 col-sm-6 col-6">
												<div className="custom-control custom-radio">
													<input 
														type="radio" 
														className="custom-control-input" 
														id="finished" 
														name="estatus" 
														value="Finalizado"
														checked={formData.estatus === 'Finalizado'}
														onChange={(e) => setFormData({ ...formData, estatus: e.target.value })}
													/>
													<label className="custom-control-label" htmlFor="finished">Finalizado</label>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-lg-12 col-md-6">
									<div className="form-group">
										<label>Fecha de Inicio *</label>
										<input 
											type="date" 
											className="form-control" 
											value={formData.fechaInicio}
											onChange={(e) => setFormData({ ...formData, fechaInicio: e.target.value })}
										/>
									</div>
								</div>
								<div className="col-lg-12 col-md-6">
									<div className="form-group">
										<label>Fecha de Fin</label>
										<input 
											type="date" 
											className="form-control" 
											value={formData.fechaFin}
											onChange={(e) => setFormData({ ...formData, fechaFin: e.target.value })}
										/>
									</div>
								</div>
								<div className="col-lg-12 col-md-12">
									<div className="form-group">
										<label>Detalles del Proyecto</label>
										<textarea 
											className="form-control" 
											placeholder="Introduce el Detalle del Proyecto"
											value={formData.detallesProyecto}
											onChange={(e) => setFormData({ ...formData, detallesProyecto: e.target.value })}
											rows="4"
										></textarea>
									</div>
								</div>
							</div>
						</form>
					</div>
					<div className="modal-footer">
						<button type="button" className="site-button" onClick={handleCloseModal}>Cancelar</button>
						<button type="button" className="site-button" onClick={handleSave}>Guardar</button>
					</div>
				</div>
			</div>
		</Modal>

	</div>
}
